// Application constants

// Validation constants
export const VALIDATION = {
  MIN_PASSWORD_LENGTH: 8,
  MIN_NAME_LENGTH: 2,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD_REGEX: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=<>?{}[\]~]).{8,}$/,
};

const getBaseUrl = () => {
  const { hostname, protocol } = window.location;

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000/api/v1/';
  }

  // Staging / Production (same domain as frontend)
  return `${protocol}//${hostname}/api/v1/`;
};

// API endpoints (for future use)
export const API_CONFIG = {
  // Always use the direct URL to the backend
  BASE_URL: getBaseUrl(),
  ENDPOINTS: {
    REFRESH_TOKEN: 'auth/token/refresh',
    LOGIN: 'auth/login',
    LOGOUT: 'auth/logout',
    REGISTER: 'auth/register',
    FORGOT_PASSWORD: 'auth/forgot-password',
    RESET_PASSWORD: 'auth/reset-password',
    USER_ROLES: 'user-roles',
    COUNTRY_SEARCH: 'countries/search',
    industry: 'industries/search',
    job_title: 'job-titles/search',
    job_level_name: 'job-levels/search',
    employee_size_range: 'employee-sizes/search',
    revenue_range: 'revenue-sizes/search',
    sic_code: 'sic-codes/search',
    naics_code: 'naics-codes/search',
    city: 'cities/search',
    zipcode: 'zipcodes/search',
    state: 'states/search',
    country: 'countries/search',
    technology_name: 'technologies/search',
    company_name: 'company-names/search',
    company_website: 'company-websites/search',
    industry_default: 'industries',
    job_title_default: 'job-titles',
    job_level_name_default: 'job-levels',
    employee_size_range_default: 'employee-sizes',
    revenue_range_default: 'revenue-sizes',
    sic_code_default: 'sic-codes',
    naics_code_default: 'naics-codes',
    city_default: 'cities',
    zipcode_default: 'zipcodes',
    state_default: 'states',
    country_default: 'countries',
    technology_name_default: 'technologies',
    company_name_default: 'company-names',
    company_website_default: 'company-websites',
    RDC_SEARCH: 'unified/count',
    RDC_DOWNLOAD_SEARCH: 'download-requests/create',
    RDC_DOWNLOAD_LIST: 'download-requests/list',
    RDC_DOWNLOAD: 'download-requests/download/',
    VDC_UPLOAD: 'download-requests/vdc',
    VDC_LIST: 'download-requests/vdc',
    VDC_DOWNLOAD: 'download-requests/vdc/',
    VDC_DOWNLOAD_ERROR: 'download-requests/vdc/',
    FDC_UPLOAD: 'fdc/create',
    FDC_LIST: 'fdc/list',
    FDC_FILTER_OPTIONS: 'fdc/filter-options',
    FDC_DEFAULT_PARTICIPANTS: 'fdc/default-participants',
    FDC_UPDATE_STATUS: 'fdc/update-status/',
    FDC_PROJECTID_LIST: 'fdc/get-project-id',
    FDC_UPDATE: 'fdc/update',
    FDC_SET_PAYMENT_COMPLETED: 'fdc/set-payment-completed',
    FDC_APPROVE_GOODWILL: 'fdc/approve-goodwill',
    FDC_GRIEVANCE_FLAG: 'fdc/customer-experience/flag',
    FDC_GRIEVANCE_UNFLAG: 'fdc/customer-experience/unflag',
    FDC_CX_APPROVE_SUFFIX: '/cx-approve',
    FDC_CX_FLAG_SUFFIX: '/cx-flag',
    FDC_REGISTER_CUSTOMER: 'fdc/register-customer',
    FDC_DOWNLOAD_SINGLE: 'fdc/download-file/',
    FDC_DOWNLOAD_PROJECT: 'fdc/download-project/',
    FDC_FILE_UPDATE_STATUS: 'fdc/file-update-status/',
    FDC_STATUS: 'fdc/status/',
    FDC_GET_LEAD: 'hubspot/get-detail/',
    FDC_SEND_EMAIL: 'fdc/send-project',
    FDC_QUICK_SEND: 'fdc/quick-send/',
    FDC_REPLACE: 'fdc/replace',
    FDC_APPEND: 'fdc/append',
    FDC_DELETE_FILE: 'fdc/delete-file/',
    FDC_GET_CUSTOMER_DETAIL: 'fdc/get-customer-details/',
    FDC_UPLOAD_CHUNK: 'fdc/upload-chunk',
    FDC_FINAL_UPLOAD: 'fdc/final-upload',
    FDC_SEND_SURVEY: 'fdc/send-survey/',
    FDC_LINK: 'fdc/get-link/',
    CHAT_OPTIONS: 'chatbot/main-options',
    CHAT_SUB_OPTIONS: 'chatbot/sub-options',
    CHAT_SUBMIT: 'chatbot/submit',
    CD_GET: 'cd/header/get',
    CD_CREATE: 'cd/header/create',
    CD_UPDATE: 'cd/header/update/',
    CD_DELETE: 'cd/header/delete/',
    RECORD_CREATE: 'cd/records/create',
    RECORD_GET: 'cd/records/get',
    RECORD_DELETE: 'cd/records/delete/',
    RECORD_GET_BY_ID: 'cd/records/get-single/',
    RECORD_UPDATE: 'cd/records/update/',
  },
  ADMIN_ENDPOINTS: {
    COUNT: 'admin/dashboard-counts',
  },
};

// Route paths
export const ROUTES = {
  SIGNIN: '/signin',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  ADMIN_DASHBOARD: '/admin/dashboard',
  RDC: '/data-centers/rdc',
  CD: '/data-centers/cd/pc-counts',
  CD_DASH: '/data-centers/cd',
  CD_COUNT_RESULT: '/data-centers/cd/database-counts-result',
  CD_COUNT: '/data-centers/cd/database-counts',
  EDIT_CD_RECORD: '/data-centers/cd/edit',
  CREATE_CD_RECORDS: '/data-centers/cd/create',
  BULK_UPLOAD_CD_RECORDS: '/data-centers/cd/bulk-upload',
  MANAGE_DATA_POINTS: '/data-centers/cd/manage-data-points',
  VDC: '/data-centers/vdc',
  VDC_REGULAR:'/data-centers/vdc/regular',
  VDC_LIST: '/data-centers/vdc/list',
  VDC_FDC: '/data-centers/vdc/fdc-upload',
  VDC_RSC: '/data-centers/vdc/rsc-upload',
  FDC: '/data-centers/fdc',
  FDC_PROJECTS: '/data-centers/fdc/projects',
  FDC_CUSTOMER_EXPERIENCE: '/data-centers/fdc/customer-experience',
  FDC_REGISTER_CUSTOMER: '/data-centers/fdc/register-customer',
  RDC_REGULAR: '/data-centers/rdc/regular',
  RDC_COUNT: '/data-centers/rdc/count',
  RDC_RDE: '/data-centers/rdc/rde',
  RDC_STATUS: '/data-centers/rdc/status',
  FDC_UPLOAD: '/data-centers/vdc/upload',
  FDC_LIST: '/data-centers/vdc/fdc-list',
  FDC_EDIT: '/data-centers/vdc/fdc-edit',
  FDC_REUPLOAD_APPEND: '/data-centers/vdc/fdc-reupload-append',

};

export const ROUTE_DESCRIPTION = [

  { name: "Dashboard", path: ROUTES.DASHBOARD },
  { name: "My Profile", path: ROUTES.PROFILE },
  { name: "Settings", path: ROUTES.SETTINGS },
  // Data Center
  { name: "RDC Home", path: ROUTES.RDC },
  { name: "RDC Regular", path: ROUTES.RDC_REGULAR },
  { name: "RDC RDE", path: ROUTES.RDC_RDE },
  { name: "RDC Status", path: ROUTES.RDC_STATUS },
  { name: "CD Home", path: ROUTES.CD },
  { name: "VDC Home", path: ROUTES.VDC },
  { name: "VDC Upload", path: ROUTES.VDC_REGULAR },
  { name: "VDC Status List", path: ROUTES.VDC_LIST },
  { name: "FDC Upload", path: ROUTES.VDC_FDC },
  { name: "FDC Home", path: ROUTES.FDC_PROJECTS },
  { name: "RSC Upload", path: ROUTES.VDC_RSC },
  { name: "FDC Project List", path: ROUTES.FDC_LIST },
];

// Error messages
export const ERROR_MESSAGES = {
  REQUIRED_FIELD: 'This field is required',
  INVALID_EMAIL: 'Please enter a valid email address',
  PASSWORD_TOO_SHORT: `Password must be at least ${VALIDATION.MIN_PASSWORD_LENGTH} characters`,
  PASSWORDS_DONT_MATCH: 'Passwords do not match',
  NAME_TOO_SHORT: `Name must be at least ${VALIDATION.MIN_NAME_LENGTH} characters`,
  GENERIC_ERROR: 'An error occurred. Please try again.',
  PASSWORD_ERROR_MESSAGE: `Password must be at least ${VALIDATION.MIN_PASSWORD_LENGTH} characters long and include uppercase, lowercase, number, and special character.`,
};

// Success messages
export const SUCCESS_MESSAGES = {
  SIGNIN_SUCCESS: 'You have been successfully signed in',
  SIGNUP_SUCCESS: 'Your account has been successfully created',
  PASSWORD_RESET_SENT: 'Password reset email has been sent',
  LOGOUT_SUCCESS: 'You have been logged out',
};

export const  headers = [
      "company_company_name",
      "company_description",
      "company_website",
      "company_founded_year",

      "company_address_street",
      "company_address_city",
      "company_address_state",
      "company_address_zipcode",
      "company_address_country",
      "company_address_type",
      "company_address_suburb",
      "county_name",

      "company_type",
      "company_public_status",

      "company_email_1",
      "company_email_verified_status_1",
      "company_phone_1",
      "company_phone_1_ext",
      "company_phone_type_1",
      "company_fax",

      "company_fiscal_year_end_month",
      "company_employee_size",
      "company_annual_revenue_amount",
      "company_projected_revenue_amount",
      "company_projected_revenue_period_in_years",
      "monthly_revenue",
      "total_assets",

      "company_industry_categories_list",
      "company_second_level_industry",
      "company_third_level_industry",

      "company_acquisition_company_name",
      "company_acquisition_date",
      "company_acquisition_amount",
      "company_investment_company_name",
      "company_investment_description",
      "company_investment_amount",
      "company_investment_round",
      "company_investment_start_date",
      "company_investment_end_date",

      "company_tech_keywords_list",
      "company_buzzwords_list",
      "company_products",
      "marketing_insights",
      "company_description_1",

      "company_social_facebook",
      "company_social_instagram",
      "company_social_linkedin",
      "company_social_twitter",
      "company_youtube",
      "company_angel_list",
      "company_crunchbase",
      "company_blog",
      "amazon_store_page",

      "sic_code",
      "naics_code",
      "duns_code",
      "npi_number",
      "cms_number",
      "gphc_number",
      "gmc_number",
      "gdc_number",

      "contract_expiration",
      "contract_initiation",
      "software_contract_expiration",
      "software_contract_initiation",
      "software_renewal_date",
      "software_purchase_date",

      "company_number_of_location",
      "brands_sold",
      "criteria_type",
      "segment",
      "list_type",
      "number_of_users",
      "ref_location",
      "home_market_value",
      "number_of_property_listing",
      "number_of_rooms",
      "number_of_beds",
      "product_category",
      "sub_specialty",
      "age_of_contacts",
      "age_of_the_facility",
      "age_of_the_practice",
      "currently_hiring_location",
      "area_of_disease",
      "event_name",
      "house_hold_income",
      "time_zone",
      "company_license_type",
      "company_number_of_servers",

      "client_file_listing_price",
      "client_file_assigned_to",
      "client_file_lead_source",
      "client_file_stage",
      "client_file_date",

      "company_business_type",
      "company_enterprise_size",
      "company_sales_territory",
      "company_account_tier",
      "company_contract_value",
      "company_annual_contract_value",
      "company_customer_since",
      "company_renewal_date",
      "company_support_tier",
      "company_sla_level",
      "company_decision_maker_count",
      "company_it_budget",
      "company_tech_stack",
      "company_integration_requirements",
      "company_purchase_authority",

      "company_src_name",

      "contact_first_name",
      "contact_middle_name",
      "contact_last_name",
      "contact_name",
      "contact_suffix",
      "contact_gender",
      "contact_date_of_birth",
      "contact_age",

      "contact_address_street",
      "contact_address_city",
      "contact_address_state",
      "contact_address_zipcode",
      "contact_address_country",
      "contact_address_type",

      "contact_email_1",
      "contact_email_verified_status_1",
      "contact_phone_1",
      "contact_phone_1_ext",
      "contact_phone_type_1",

      "contact_job_title_1",
      "contact_job_title_level_1",
      "contact_job_start_date_1",
      "contact_job_end_date_1",
      "contact_reporting_authority_1",
      "contact_job_dept_name_1",
      "contact_job_role_name_1",
      "contact_job_function_name_1",

      "contact_social_facebook",
      "contact_social_instagram",
      "contact_social_linkedin",
      "contact_social_twitter",

      "contact_suffix_local_language",
      "contact_suffix_english_language",
      "contact_income",
      "contact_school_name",
      "graduation_year",
      "contact_credentials",

      "contact_department",
      "contact_decision_authority",
      "contact_budget_authority",
      "contact_purchase_influence",
      "contact_technical_authority",
      "contact_seniority_level",
      "contact_direct_reports_count",
      "contact_territory",
      "contact_quota_amount",
      "contact_quota_achievement",
      "contact_skills_competencies",
      "contact_certifications",
      "contact_vertical_expertise",
      "contact_engagement_score",
      "contact_last_engagement_date",
      "contact_preferred_contact_method",
      "contact_account_relationship",
      "contact_opportunity_stage",
      "contact_deal_size",
      "contact_sales_cycle_stage",

      "contact_src_name"
    ];
